module.exports = __webpack_public_path__ + "img/2019qinglongxia-2.c27c7b23.jpg";